import { createFileRoute } from '@tanstack/react-router';

import { QuotationTemplateBuilderPage } from '@/areas/quotations/QuotationTemplates/QuotationTemplateBuilderPage';
import { canEditQuotationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// One route for a new and a saved template, so the first save keeps the builder and its AI chat mounted.
export const Route = createFileRoute('/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}')({
    staticData: { access: { permissions: canEditQuotationTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { templateId } = Route.useParams();
    return <QuotationTemplateBuilderPage templateId={templateId} />;
}
